import { useState, useMemo } from 'react'
import './TemplatePicker.scoped.scss'

export default function TemplatePicker({ templates, onSelectTemplate }) {
  const [searchQuery, setSearchQuery] = useState('')

  const filteredAndSortedTemplates = useMemo(() => {
    const filtered = templates.filter((t) => {
      if (!searchQuery.trim()) return true
      return t.name.toLowerCase().includes(searchQuery.toLowerCase())
    })

    return filtered.sort((a, b) => {
      const dateA = new Date(a.createdAt)
      const dateB = new Date(b.createdAt)
      return dateB - dateA
    })
  }, [templates, searchQuery])

  function formatDate(dateString) {
    if (!dateString) return ''
    const date = new Date(dateString)
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })
  }

  function prettifyKind(kind) {
    if (!kind) return ''
    return kind.replace('twilio/', '').replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
  }

  return (
    <>
      <p className="bold">Choose a template</p>
      {templates.length > 0 && (
        <div className="template-search">
          <input
            type="text"
            placeholder="Search templates by name..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
        </div>
      )}
      {filteredAndSortedTemplates.length > 0 && (
        <div className="whatsapp-templates">
          {filteredAndSortedTemplates.map((template) => (
            <div className="whatsapp-template" key={template.id}>
              <div className="left">
                <p className="bold no-margin-top no-margin-bottom template-slug">
                  <span className="ellipsis green"></span>
                  <b>{template.name}</b>
                </p>
                {template.kind && <span className="tag">{prettifyKind(template.kind)}</span>}
                <p className="added-date">Added {formatDate(template.createdAt)}</p>
              </div>
              <div className="inner-box template-preview">
                <p
                  className="text"
                  dangerouslySetInnerHTML={{
                    __html: template.body.replace(/\n/g, '<br/>'),
                  }}
                ></p>
                <a
                  onClick={() => onSelectTemplate(template)}
                  className="button primary small"
                >
                  Use this template
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
      {filteredAndSortedTemplates.length === 0 && templates.length > 0 && (
        <p>No templates match your search.</p>
      )}
      {templates.length > 0 && (
        <p className="small muted">
          Need to delete a template? Please contact support via email.
        </p>
      )}
      {templates.length === 0 && (
        <p>
          You currently don't have any WhatsApp templates set up. Please get in
          touch via support.
        </p>
      )}
    </>
  )
}
